import { pdfjs } from 'react-pdf';

// Reaproveita o mesmo worker já usado pelo react-pdf no restante do app
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

// Marcadores de um "VNS Therapy Session Report" (LivaNova) — validação leve.
// O aparelho emite o relatório no idioma configurado no software da clínica, então há um
// conjunto de marcadores por idioma; basta o arquivo conter todos os trechos de UM idioma.
const MARCADORES_POR_IDIOMA = [
    // inglês
    [/VNS Therapy Session Report/i, /Serial Number/i, /Patient ID/i],
    // espanhol
    [/Informe de sesi[óo]n de tratamiento con VNS/i, /N[úu]mero de serie/i, /ID del paciente/i],
];

async function extrairTextoPdf(file) {
    const buffer = await file.arrayBuffer();
    const pdf = await pdfjs.getDocument({ data: buffer }).promise;
    let texto = '';
    for (let pagina = 1; pagina <= pdf.numPages; pagina++) {
        const page = await pdf.getPage(pagina);
        const content = await page.getTextContent();
        texto += content.items.map(item => item.str).join(' ') + '\n';
    }
    return texto;
}

/**
 * Valida (no front, de forma leve) se o arquivo enviado é um relatório
 * "VNS Therapy Session Report" da LivaNova, checando marcadores no texto do PDF.
 * Retorna { ok: boolean, motivo?: string }.
 */
export async function validarPdfMonitoramentoVns(file) {
    if (!file) {
        return { ok: false, motivo: 'Nenhum arquivo selecionado.' };
    }

    const ehPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name || '');
    if (!ehPdf) {
        return { ok: false, motivo: 'O arquivo precisa ser um PDF do relatório VNS Therapy.' };
    }

    let texto = '';
    try {
        texto = await extrairTextoPdf(file);
    } catch (e) {
        return { ok: false, motivo: 'Não foi possível ler o PDF. Verifique se o arquivo não está corrompido.' };
    }

    const textoNormalizado = (texto || '').replace(/\s+/g, ' ').trim();

    if (!textoNormalizado) {
        return {
            ok: false,
            motivo: 'Não foi possível ler o conteúdo do PDF (o arquivo pode ser uma imagem/digitalização). Envie o relatório original gerado pelo aparelho.',
        };
    }

    const reconhecido = MARCADORES_POR_IDIOMA.some(marcadores => marcadores.every(regex => regex.test(textoNormalizado)));
    if (!reconhecido) {
        return {
            ok: false,
            motivo: 'O arquivo está fora do padrão: não parece ser um relatório VNS Therapy Session Report.',
        };
    }

    return { ok: true };
}
